import React, { useState } from "react";
import {
  Container,
  Card,
  CardContent,
  CardActions,
  Grid,
  FormControl,
  TextField,
  Button,
  Divider,
  Box,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter, Link } from "react-router-dom";
import { compose } from "recompose";
import LoadingOverlay from "react-loading-overlay";

import { useError } from "../ErrorProvider";
import { SignUpLink } from "../Signup";
import { withFirebase } from "../Firebase";
import PasswordResetLink from "../Passwordreset";
import * as ROUTES from "../../constants/routes";
import utils from "../utils";

import Header from "../CompanyHeader";
import { ResponsiveClasses } from "../StyledComponents";

const useStyles = makeStyles({
  signInText: {
    display: "inline",
    marginRight: "8px",
  },
  resetLink: {
    textAlign: "center",
    marginTop: 8,
  },
});

const SignInPage = () => {
  const classes = useStyles();
  return (
    <Container fixed>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Header />
        </Grid>
        <Grid item xs={12} sm={8} md={5}>
          <Card>
            <CardContent>
              <Box mb={2}>
                <Typography variant="h4">Sign In</Typography>
              </Box>
              <SignInForm />
              <div className={classes.resetLink}>
                <PasswordResetLink />
              </div>
            </CardContent>
            <Divider orientation="horizontal" variant="fullWidth" />
            <CardActions disableSpacing>
              <Box flexBasis="100%" textAlign="center">
                <SignUpLink />
              </Box>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

const INITIAL_STATE = {
  email: "",
  password: "",
};

const SignInFormBase = ({ firebase, history }) => {
  const [state, setState] = useState(INITIAL_STATE);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const errorProvider = useError();

  const onSubmit = (event) => {
    const { email, password } = state;
    setLoading(true);
    firebase
      .doSignInWithEmailAndPassword(email, password)
      .then((d) => {
        setState({ ...INITIAL_STATE });

        firebase
          .resolveRedirect()
          .then((redirectPath) => {
            history.replace(redirectPath);
          })
          .catch((err) => {
            console.log(err);
            history.replace(ROUTES.USERDASHBOARD);
          });
      })
      .catch((error) => {
        errorProvider.showError(error);
        setLoading(false);
      });
    event.preventDefault();
  };

  const onChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const isInvalid = state.password === "" || state.email === "";

  return (
    <LoadingOverlay active={loading} spinner>
      <form onSubmit={onSubmit}>
        <TextField
          label="Email"
          type="email"
          placeholder="Email"
          name="email"
          variant="outlined"
          value={state.email}
          onChange={onChange}
          onBlur={() =>
            setEmailError(
              state.email !== "" && !utils.validateEmailAddress(state.email)
            )
          }
          error={emailError}
          helperText={emailError ? "Enter a valid email address." : ""}
          fullWidth
        />
        <TextField
          label="Password"
          type="password"
          placeholder="Password"
          name="password"
          variant="outlined"
          value={state.password}
          onChange={onChange}
          fullWidth
        />
        <FormControl fullWidth>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isInvalid}
          >
            Sign In
          </Button>
        </FormControl>
      </form>
    </LoadingOverlay>
  );
};

const SignInLink = () => {
  const responsive = ResponsiveClasses();
  const classes = useStyles();
  return (
    <div>
      <Typography variant="body2" className={classes.signInText}>
        Already have an account?
      </Typography>
      <Link
        to={ROUTES.SIGNIN}
        replace={true}
        className={responsive.breakOnSmall}
      >
        Sign In
      </Link>
    </div>
  );
};

const SignInForm = compose(withRouter, withFirebase)(SignInFormBase);

export default SignInPage;
export { SignInForm, SignInLink };
